// Generated types for PDMProduct
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { DevelopmentStage } from '../../shared/enums';

import { IslandRootReadAPI, IslandRootWriteAPI } from '../../shared/types/islandroot';
import { PDMActionWriteAPI } from './pdmaction';
import { PDMRequirementWriteAPI } from './pdmrequirement';
import { PDMSupplyChainCriteriaWriteAPI } from './pdmsupplychaincriteria';
import { SysMLStructureReadAPI, SysMLStructureWriteAPI } from '../../sysml/types/sysmlstructure';
import { IslandRootReadAPISchemaObject, IslandRootWriteAPISchemaObject } from '../../shared/types/islandroot';
import { PDMActionWriteAPISchema } from './pdmaction';
import { PDMRequirementWriteAPISchema } from './pdmrequirement';
import { PDMSupplyChainCriteriaWriteAPISchema } from './pdmsupplychaincriteria';
import { SysMLStructureReadAPISchemaObject, SysMLStructureWriteAPISchemaObject } from '../../sysml/types/sysmlstructure';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface PDMProductReadAPI extends SysMLStructureReadAPI, IslandRootReadAPI {
  /** Category of product */
  product_category: string;
  /** Current development stage */
  development_stage?: DevelopmentStage;
  /** Target market */
  target_market?: string | null;
  /** Retired: kept for the islands that use it, never used anew — a new link or reference to it is refused. */
  retired?: boolean;
}

export interface PDMProductWriteAPI extends SysMLStructureWriteAPI, IslandRootWriteAPI {
  /** Category of product */
  product_category: string;
  /** Current development stage */
  development_stage?: DevelopmentStage;
  /** Target market */
  target_market?: string | null;
  /** Retired: kept for the islands that use it, never used anew — a new link or reference to it is refused. */
  retired?: boolean;
  /** Top-level product requirements */
  requirements?: (string | PDMRequirementWriteAPI)[];
  /** High-level actions/functions this product performs */
  actions?: (string | PDMActionWriteAPI)[];
  /** Supply chain criteria for this product */
  supply_chain?: (string | PDMSupplyChainCriteriaWriteAPI)[];
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const PDMProductReadAPISchema: z.ZodType<PDMProductReadAPI> = SysMLStructureReadAPISchemaObject.extend(IslandRootReadAPISchemaObject.shape).extend({
  product_category: z.string(),
  development_stage: z.nativeEnum(DevelopmentStage).optional(),
  target_market: z.string().nullable().optional(),
  retired: z.boolean().optional(),
}).passthrough();

export const PDMProductWriteAPISchema: z.ZodType<PDMProductWriteAPI> = SysMLStructureWriteAPISchemaObject.extend(IslandRootWriteAPISchemaObject.shape).extend({
  product_category: z.string(),
  development_stage: z.nativeEnum(DevelopmentStage).optional(),
  target_market: z.string().nullable().optional(),
  retired: z.boolean().optional(),
  requirements: z.array(z.union([z.string(), z.lazy(() => PDMRequirementWriteAPISchema)])).optional(),
  actions: z.array(z.union([z.string(), z.lazy(() => PDMActionWriteAPISchema)])).optional(),
  supply_chain: z.array(z.union([z.string(), z.lazy(() => PDMSupplyChainCriteriaWriteAPISchema)])).optional(),
}).passthrough();
